import { configureStore } from '@reduxjs/toolkit'
import dppReducer from './slices/dppSlice'
import scannerReducer from './slices/scannerSlice'
import uiReducer from './slices/uiSlice'

export const store = configureStore({
  reducer: {
    dpp: dppReducer,
    scanner: scannerReducer,
    ui: uiReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
